const API_RESPONSE_CODE = {
  ACCESS_DENIED: "ACCESS_DENIED",
  APP_CRASH: "APPLICATION_CASHED",
  PRODUCTION_DEPLOYMENT: "PRODUCTION_DEPLOYMENT",
  PROJECT_NAME_ALREADY_EXIST: "MD_PROJECT_NAME_ALREADY_EXIST",
  SHARE_PROJECT_REQUEST_UNLOCK_SENT: "MD_REQUEST_UNLOCK_PROJECT",
  SHARE_PROJECT_LOCK_GRANTED: "MD_AUTO_UNLOCK_PROJECT",
  SUCCESS: "SUCCESS",
  MD_SAVE_FOLDER_DATAEXIST: "MD_SAVE_FOLDER_DATAEXIST",
  US_INVALID_WATER_SUB_TYPE_ID: "US_INVALID_WATER_SUB_TYPE_ID",
  CALC_ENGINE_ERROR: "CALC_ENG_INTERNAL_SERVER_ERROR",
  CALC_ENG_CONVERGE: "CALC_ENG_COULD_NOT_CONVERGE",
  CALC_ENG_VALUE_ERROR: "CALC_ENG_DATA_VALUE_ERROR",
  CALC_ENG_INVALID_INPUT: "CALC_ENG_INVALID_INPUT",
  CALC_IX_INVALID_TDS: "CALC_IX_INVALID_TDS",
  CALC_ENG_LOGIC_ERROR: "CALC_ENG_LOGIC_ERROR",
  CALC_ENG_TIMEOUT: "CALC_ENG_TIMEOUT",
  INTERNAL_SERVER_ERROR: "INTERNAL_SERVER_ERROR",
  CALC_ENG_INTERNAL_SERVER_ERROR: "CALC_ENG_INTERNAL_SERVER_ERROR",
  CALC_MLD_JOB_IN_PROGRESS: "CALC_MLD_JOB_IN_PROGRESS",
};

export const HTTP_STATUS_CODE = {
  // 2XX Success
  OK: 200,
  CREATED: 201,
  ACCEPTED: 202,
  NO_CONTENT: 204,
  // 4XX Client Errors
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  // 5XX Server Errors
  INTERNAL_SERVER_ERROR: 500,
  NOT_IMPLEMENTED: 501,
  BAD_GATEWAY: 502,
  SERVICE_UNAVAILABLE: 503,
  GATEWAY_TIMEOUT: 504,
};

export const FULL_SCREEN_ERROR_CODES = [
  // HTTP_STATUS_CODE.SERVICE_UNAVAILABLE,
  API_RESPONSE_CODE.ACCESS_DENIED,
  HTTP_STATUS_CODE.UNAUTHORIZED,
  HTTP_STATUS_CODE.FORBIDDEN,
  API_RESPONSE_CODE.APP_CRASH,
];

export default API_RESPONSE_CODE;
